exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".user-row {\n  max-width: 324px;\n  width: 100%;\n  height: 249px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  background-color: white;\n  border-radius: 20px;\n  margin: 33.5px;\n  transition: transform 0.2s;\n  cursor: pointer; }\n  .user-row span {\n    color: #4a4a4a;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    overflow: hidden; }\n  .user-row:hover {\n    transform: scale(1.02); }\n\n.card-holder {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center; }\n\n@media (max-width: 600px) {\n  .user-row {\n    margin: 10px 0; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/screens/users/Users.scss
// module id = 861
// module chunks = 0